module.exports = __webpack_public_path__ + "static/media/menu-arrow-up.a3b3e3ca.svg";